import { createApp } from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import store from './store';
import tippy, { Props } from 'tippy.js';
import 'tippy.js/dist/tippy.css';

//import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css';

import { emitter } from './emitter';

createApp(App)
  .provide('emitter', emitter)
  .use(store)

  .directive('tooltip', {
    mounted(el, binding) {
      tippy(el, binding.value as Partial<Props>);
    },
  })
  .mount('#app');
